import { render, staticRenderFns } from "./linkAccount.vue?vue&type=template&id=02bf195a"
import script from "./linkAccount.vue?vue&type=script&lang=js"
export * from "./linkAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports